{
    "May the force be with you": "Que la força t'acompanye",
    "Digit1": "1",
    "Digit2": "2",
    "Digit3": "3",
    "Digit4": "4",
    "Digit5": "5",
    "Digit6": "6",
    "Digit7": "7",
    "Digit8": "8",
    "Digit9": "9",
    "Digit0": "0",
    "KeyA": "A",
    "KeyB": "B",
    "KeyC": "C",
    "KeyD": "D",
    "KeyE": "E",
    "KeyF": "F",
    "KeyG": "G",
    "KeyH": "H",
    "KeyI": "I",
    "KeyJ": "J",
    "KeyK": "K",
    "KeyL": "L",
    "KeyM": "M",
    "KeyN": "N",
    "KeyO": "O",
    "KeyP": "P",
    "KeyQ": "Q",
    "KeyR": "R",
    "KeyS": "S",
    "KeyT": "T",
    "KeyU": "U",
    "KeyV": "V",
    "KeyW": "W",
    "KeyX": "X",
    "KeyY": "Y",
    "KeyZ": "Z",
    "Comma": ",",
    "Period": ".",
    "Semicolon": ";",
    "Quote": "'",
    "BracketLeft": "[",
    "BracketRight": "]",
    "Backquote": "`",
    "Backslash": "\\\\",
    "Minus": "-",
    "Equal": "=",
    "AltLeft": "Alt",
    "AltRight": "Alt",
    "CapsLock": "Bloq. Maj.",
    "ControlLeft": "Ctrl",
    "ControlRight": "Ctrl",
    "OSLeft": "OS esquerra",
    "OSRight": "OS dreta",
    "ShiftLeft": "Majúscules",
    "ShiftRight": "Majúscules",
    "ContextMenu": "Menú contextual",
    "Enter": "Intro",
    "Space": "Espai",
    "Tab": "Tabulador",
    "Delete": "Suprimir",
    "End": "Final",
    "Help": "Ajuda",
    "Home": "Inici",
    "Insert": "Inserir",
    "PageDown": "Pàgina avall",
    "PageUp": "Pàgina amunt",
    "ArrowDown": "Fletxa avall",
    "ArrowLeft": "Fletxa esquerra",
    "ArrowRight": "Fletxa dreta",
    "ArrowUp": "Fletxa amunt",
    "Escape": "Escape",
    "PrintScreen": "Imprimir pantalla",
    "ScrollLock": "Bloq. desplaçament",
    "Pause": "Pausa",
    "Put the videos side by side": "Col·locar els vídeos costat a costat",
    "Minimize video": "Minimitzar vídeo",
    "Close video": "Tancar el vídeo",
    "Place the video on the other side of the screen": "Col·locar el vídeo a l'altra banda de la pantalla",
    "Maximize video": "Maximitzar vídeo",
    "Swap position of the videos": "Intercanviar la posició dels vídeos",
    "loadManifest(): Invalid current player state: $1": "loadManifest(): Estat actual del reproductor no vàlid: $1",
    "loadPlayer(): Invalid current player state: $1": "loadPlayer(): Estat actual del reproductor no vàlid: $1",
    "Could not load player: state transition in progress: $1": "No s'ha pogut carregar el reproductor: transició d'estat en curs: $1",
    "Could not unload player: state transition in progress: $1": "No s'ha pogut descarregar el reproductor: transició d'estat en curs: $1",
    "unloadManifest(): Invalid current player state: $1": "unloadManifest(): Estat actual del reproductor no vàlid: $1",
    "Error loading video manifest: $1 $2": "Error carregant el manifest del vídeo: $1 $2",
    "Play/pause": "Reproduir/pausar",
    "Select the active audio track": "Seleccioneu la pista d'àudio activa",
    "Toggle audio mute": "Canviar silenci d'àudio",
    "Toggle play/pause": "Alternar reproducció/pausa",
    "Toggle captions": "Alternar subtítols",
    "Backward $1 seconds": "Retrocedir $1 segons",
    "Forward $1 seconds": "Avançar $1 segons",
    "Volume up 10%": "Augmentar el volum un 10%",
    "Volume down 10%": "Reduir el volum un 10%",
    "Close pop-up": "Tancar la finestra emergent",
    "Decrease playback speed": "Reduir la velocitat de reproducció",
    "Increase playback speed": "Augmentar la velocitat de reproducció",
    "Swap between side by side and minimized video": "Canviar entre vídeos costat a costat i vídeo minimitzat",
    "Swap the position of the videos": "Intercanviar la posició dels vídeos",
    "Dual stream 50%": "Dos fluxos al 50%",
    "Two videos 50%": "Dos vídeos 50%",
    "Play/Pause button": "Botó Reproduir/Pausar",
    "Starts and stops video playback. When the video reaches the end, this button also allows you to restart playback from the beginning.": "Inicia i atura la reproducció del vídeo. Quan el vídeo arriba al final, aquest botó també et permet reiniciar la reproducció des del principi.",
    "Toolbar": "Barra d'eines",
    "Left-side buttons": "Botons de l'esquerra",
    "Right-side buttons": "Botons de la dreta",
    "Back": "Enrere",
    "Play": "Reproduir",
    "playPauseButtonHelp.title": "Ajuda del botó Reproduir/Pausar",
    "playPauseButtonHelp.description": "Aquest botó et permet reproduir o posar en pausa el vídeo.",
    "Options": "Opcions",
    "Configuration options": "Opcions de configuració",
    "Settings": "Ajustos",
    "Settings options": "Opcions d'ajustament"
}